import Constantes from "./Constantes";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
//import Cookies from 'universal-cookie';

/**
 * The integrated application serves React and REST from the same Payara origin.
 * An explicit build-time override is kept only for the optional hot-reload/CORS
 * development mode.
 */
export function resolveBackendBase(
  locationInput = window.location,
  configuredOrigin = process.env.REACT_APP_API_ORIGIN
) {
  const override = String(configuredOrigin || "").trim();
  if (override) {
    const parsed = new URL(override);
    if (!['http:', 'https:'].includes(parsed.protocol)) {
      throw new Error('REACT_APP_API_ORIGIN must use http or https');
    }
    return parsed.origin;
  }

  if (locationInput?.origin && locationInput.origin !== 'null') {
    return locationInput.origin.replace(/\/$/, '');
  }

  const { protocol, hostname, port } = locationInput;
  return protocol + "//" + hostname + (port ? ":" + port : "");
}

export function buildApiUrl(app, method, locationInput = window.location, configuredOrigin) {
  const url = resolveBackendBase(locationInput, configuredOrigin)
    + "/"
    + Constantes.API_BASE
    + "/";

  const appPaths = {
    SSO: Constantes.URL_SSO,
    BOX: Constantes.URL_BOX,
    CCON: Constantes.URL_CCON,
    CUBE: Constantes.URL_CUBE,
    TABL: Constantes.URL_TABL,
    HAPK: Constantes.URL_HAPK,
    TEAN: Constantes.URL_TEAN,
    MUGIN: Constantes.URL_MUGIN,
    MFM: Constantes.URL_MFM,
    EXHI: Constantes.URL_EXHI,
    CHAMP: Constantes.URL_CHAMP,
    MTA: Constantes.URL_MTA,
  };

  return url + (appPaths[app] || "") + method;
}

export async function doFetch(app, method, requestOptionsInput) {
  // Extract _silent flag before merging into fetch options
  const silent = requestOptionsInput?._silent === true;
  if (requestOptionsInput) {
    const { _silent, ...rest } = requestOptionsInput;
    requestOptionsInput = rest;
  }

  const url = buildApiUrl(app, method);

  let requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {},
  };

  Object.assign(requestOptions, requestOptionsInput);

  let responseRes;

  await fetch(url, requestOptions)
    .then((response) => {
      if (!silent && response.status === 401) {
        toast.show({
          message: "No dispone de permisos para realizar esta acción o su sesión ha caducado.",
          type: "danger",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 3000,
        });
      } else if (!silent && response.status === 403) {
        toast.show({
          message: "No dispone de permisos para realizar esta acción.",
          type: "danger",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 3000,
        });
      }
      if (response.status >= 400) {
        console.warn(`[ConnectionManager] HTTP ${response.status} ${response.statusText} → ${url}`);
      }
      responseRes = response;
    })
    .catch((error) => {
      console.error("Error al obtener datos:", JSON.stringify(error, null, 2));
    })
    .finally(() => {});

  return responseRes;
}

/**
 * Wrapper sobre doFetch que parsea automáticamente el JSON de la respuesta.
 * Devuelve el objeto JSON directamente (equivalente a doFetch + .json()).
 */
export async function doFetchJson(app, method, requestOptions) {
  const response = await doFetch(app, method, requestOptions);
  if (!response) return null;
  try {
    const json = await response.json();
    if (json?.STATE && json.STATE !== "SUCCESS" && json.STATE !== "WARNING") {
      console.warn(`[doFetchJson] ${app}/${method} → STATE=${json.STATE} | ${json.MESSAGE || ""}`);
    }
    return json;
  } catch (_) {
    // La respuesta no tiene cuerpo JSON (ej. 404 HTML de servidor)
    console.warn(`[doFetchJson] ${app}/${method} → HTTP ${response.status} sin cuerpo JSON`);
    return { STATE: String(response.status), MESSAGE: `HTTP ${response.status} ${response.statusText || ""}`.trim() };
  }
}
